<template>
	<div>


		<div class="bj_img_h m-slider" style="margin-top: 20px;">

			<img width="100%" :src="List_a.imgages_sma_a" />

			<div style="margin-top: 20px; margin-bottom: 20px;">
				<h4 class="h_hei">{{List_a.title}}</h4>

				<div class="row" style="margin-top: 20px; line-height: 30px;">
					<div class="col-3" style="text-align: right;">
						惠享折扣
					</div>
					<div class="col-9" style="font-size: 30px;">
						<b>{{List_a.price_b}}</b>
					</div>
				</div>
				<div class="row" style="margin-top: 10px; line-height: 30px;" v-if="List_a.imgages_sma_b!=''">
					<div class="col-3" style="text-align: right;">
						其它惠享
					</div>
					<div class="col-9">
						<b>{{List_a.imgages_sma_b}}</b>
					</div>
				</div>

				<div class="row" style="margin-top: 20px;">
					<div class="col-3" style="text-align: right;">
						经营范围
					</div>
					<div class="col-9">
						{{List_a.describe}}
					</div>
				</div>
				<div class="row" style="margin-top: 10px;">
					<div class="col-3" style="text-align: right;">
						联系电话
					</div>
					<div class="col-9" style="font-size: 16px;">
						<b>
						<a :href="'tel:' + List_a.connect" rel="external nofollow">{{List_a.connect}}</a>


						</b>
					</div>
				</div>
				<div style="margin-top: 20px; margin-bottom: 20px;">
					<h4 class="h_hei">地址</h4>
					<div style="margin: 20px;">
						{{List_a.address}}
					</div>
				</div>


				<h4 class="h_hei">简介</h4>
				<div style="font-size: 16px;">
					<p v-html="List_a.detailed"></p>
				</div>





			</div>

		</div>
		<div style="height: 20px;"></div>
	</div>
</template>

<script>
	import QRCode from 'qrcodejs2'
	export default {
		data() {
			return {
				List_a: {},
			}
		},
		mounted() {
			this.list_a();
		},
		methods: {
			//查询用户
			list_a() {
				var datas = this.$route.query.id;
				//this.$route.query.id
				this.$api.getAPI("data/product/" + datas + "?type_id=2022040010", {}).then(res => {
					if (res.data.code == 200) {
						this.List_a = res.data.data.models;
					}
				})
			},

		}
	}
</script>

<style>
	.header {
		height: 160px;
		color: #fff;
		background: url("http://www.baiduhrb.com/fjh/images/user_bg.png");
		background-size: 100% 100%;
	}

	.header .logo_data {
		display: block;
		float: left;
		margin-left: .8rem;
		margin-top: -25px;
	}

	.header .logo_data img {
		position: relative;
		overflow-x: hidden;
		width: 45%;
		height: auto;
		top: 0px;
	}

	.bin_tijiao_data {
		height: 50px;
		width: 100%;
		font-size: 16px;
		opacity: 0.6;
	}

	.m-slider {
		overflow-x: hidden;
		position: relative;
		border-radius: .45em;
	}

	.zhibo {
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.loupan {
		opacity: 0.6;
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.jiage {
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.h_hei {
		border-left: 5px solid #c5114f;
		padding-left: 5px;
	}

	.container-fluid {
		margin-top: 0px !important;
		max-width: 1200px;
	}

	.el-tabs__item {
		font-size: 16px !important;


	}

	.el-tabs__item is-top is-active {
		width: 50% !important;
	}

	.er_img img {
		text-align: center;
		width: 100%;
	}

	.el-form-item__label {
		text-align: left !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/jjgh/gfhx_show.vue